import { FC, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { getInvoiceById } from "../../redux/actions/invoiceAction";
import { AppDispatch } from "../../redux/store";
import { InvoiceData } from "../../Typings/dataListing";
import ImageModal from '../../components/ImageModal';

const InvoiceView: FC = () => {
  const { invoiceid } = useParams<{ invoiceid: string }>();
  const invoiceIdInt = invoiceid ? parseInt(invoiceid, 10) : 0;
  const dispatch = useDispatch<AppDispatch>();
  const [invoiceData, setInvoiceData] = useState<InvoiceData | null>(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    GetInvoiceData();
  }, [dispatch]);

  const GetInvoiceData = async () => {
    const payload = { invoiceid: invoiceIdInt };
    try {
      dispatch(
        getInvoiceById(payload, (response: any) => {
          const invoiceDate = response?.data;
          if (invoiceDate) {
            setInvoiceData(invoiceDate);
            setImageUrl(invoiceDate.fileItem?.webUrl || '');
          }
        })
      );
    } catch (error) {
      console.error("Error fetching invoice details:", error);
    }
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">View Invoice</span>
              Invoice Id: {invoiceData?.invoiceid || "N/A"}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                State{" "}
                <span className="d-block pt-1">
                  {invoiceData?.state || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Username{" "}
                <span className="d-block pt-1">
                  {invoiceData?.username || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Latitude{" "}
                <span className="d-block pt-1">
                  {invoiceData?.latitude || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Longitude{" "}
                <span className="d-block pt-1">
                  {invoiceData?.longitude || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Timestamp{" "}
                <span className="d-block pt-1">
                  {invoiceData?.timestamp || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Task Date{" "}
                <span className="d-block pt-1">
                  {invoiceData?.task_date || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Import Date{" "}
                <span className="d-block pt-1">
                  {invoiceData?.import_date || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Name of Input{" "}
                <span className="d-block pt-1">
                  {invoiceData?.task_name_of_input || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Total Cost of Receipt{" "}
                <span className="d-block pt-1">
                  {invoiceData?.task_total_cost_of_the_receipt.toFixed(2) ||
                    "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Only for Enrolled Fields{" "}
                <span className="d-block pt-1">
                  {invoiceData?.task_only_for_enrolled_fields.toFixed(2) || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Task End Timestamp{" "}
                <span className="d-block pt-1">
                  {invoiceData?.task_task_end_timestamp || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Survey Version{" "}
                <span className="d-block pt-1">
                  {invoiceData?.task_survey_version || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Image File Name{" "}
                <span className="d-block pt-1">
                  {invoiceData?.image_file_name || "-"}&nbsp;
                  <button
                    type="button"
                    className="ViewButton"
                    onClick={() => setIsImageModalOpen(true)}
                  >
                    <span className="material-icons-outlined">visibility</span>
                  </button>
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Status{" "}
                <span className="d-block pt-1">
                  {invoiceData?.status || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Downloaded{" "}
                <span className="d-block pt-1">
                  {invoiceData?.downloaded !== null
                    ? invoiceData?.downloaded
                      ? "Yes"
                      : "No"
                    : "-"}
                </span>
              </li>
            </ul>
            <div className="pt-5 text-end">
              <NavLink to="/Invoice">
                <button type="button" className="formBtn cancel">
                  Cancel
                </button>
              </NavLink>
              <NavLink to={`/Invoice/edit/${invoiceData?.invoiceid || "-"}`}>
                <button type="button" className="ms-3 formBtn">
                  Edit Details
                </button>
              </NavLink>
            </div>
          </div>
        </section>
      </div>
      <ImageModal
        isOpen={isImageModalOpen}
        imageUrl={imageUrl}
        onClose={() => setIsImageModalOpen(false)}
      />
      <Footer />
    </div>
  );
};

export default InvoiceView;
